import { hasAnyRole } from '../../../auth/roles'
import type { Profile } from '../../../lib/types'
import { useMe } from '../../users/useUsers'
import { useMyEdoRoles } from '../useEdo'
import { PersonPickField } from './PersonPickField'

/**
 * «Подать от имени сотрудника» (роль proxy): пикер сотрудника для личных заявок за тех, у кого
 * нет доступа к порталу (водители и т.п.). Виден только носителю ЭДО-роли proxy или admin —
 * прочим рендерится null, и форма работает как обычно. Выбранный сотрудник становится
 * инициатором заявки на бэке (resolveOnBehalf): маршрут, балансы и 1С считаются от него.
 */
export function OnBehalfField({
  value,
  onChange,
}: {
  value: Profile | null
  onChange: (p: Profile | null) => void
}) {
  const me = useMe()
  const { data: edoRoles } = useMyEdoRoles()
  const allowed = hasAnyRole(me.data, ['admin']) || !!edoRoles?.roles.includes('proxy')
  if (!allowed) return null

  return (
    <PersonPickField
      label={{ ru: 'Подать от имени сотрудника', en: 'Submit on behalf of an employee' }}
      // Подсказка только после выбора сотрудника — как и было.
      hint={
        value
          ? {
              ru: 'Заявка будет оформлена на этого сотрудника: маршрут и лимиты — его.',
              en: 'The request is filed for this employee: route and limits are theirs.',
            }
          : undefined
      }
      value={value}
      onChange={onChange}
      excludeIds={me.data ? [me.data.id] : []}
    />
  )
}
